<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick"  @checkbox="checkbox" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import Url from "@/views/other/util/url"
    import download from '@/utils/download'
    let opType = {"1":window.$t("other.topic.support"),"2":window.$t("other.topic.oppose")};
    let topicList = {};
    let check=[];
    let commentStatus={"0":window.$t("other.public.notAudit"),"1":window.$t("other.public.pass"),"2":window.$t("other.public.noPass")};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        created(){
            this.getTopicList(this.$route.query.topicId);
        },
        mounted(){
        },
        methods: {
          checkbox(rows){
              this.check = rows;
              console.log(rows);
          },
          /*表格按钮点击事件*/
          bthClick (clickName, row) {
            if (clickName == "update"){
              row.time = [row.startTime,row.endTime];
              this.$refs.childUpdate.open(row);
            }else if (clickName == "updateStatus"){
                this.$axios.get(`${Url.topicUser.update}/${row.id}`+'?status='+row.topicStatus).then(res => {
                  if (res.code == 0){
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                  }else{
                    this.$message.error(res.message);
                  }
                });
            }else if(clickName == "top"){
                this.$axios.get(`${Url.topicUser.update}/${row.id}`+'?seq='+row.seq).then(res => {
                    if (res.code == 0){
                        this.$refs.childTable.defaultGetData(this.queryData);
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                });
            }
          },
            batchSubmit(){
              let ids = "";
                for (const i in this.check){
                    if(ids == ""){
                        ids=this.check[i].id;
                    }else{
                        ids=ids+","+this.check[i].id;
                    }
                }
                if(ids == "" || ids == null){
                    this.$message.error(window.$t("other.topic.batchAudit"));
                    return;
                }
                this.$axios.get(`${Url.topicUser.batchUpdate}`+'?ids='+ids).then(res => {
                    if (res.code == 0){
                        this.$refs.childTable.defaultGetData(this.queryData);
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                });
            },
            downloadTopicComments(data){
                download.exportExcel(Url.topicUser.downloadTopicComments, data, window.$t("other.topic.topicMessage"));
            },
            getTopicList(topicId){
                topicId =  topicId != null && topicId != 'undefined' ? topicId : '';
                this.$axios.get(Url.topic.all+'?topicId='+topicId).then(res => {
                    if (res.code == 0){
                        let data=JSON.parse(JSON.stringify(res.result));
                        for (const i in data){
                            data[i].value=data[i].title
                            data[i].key=data[i].topicId
                        }
                        for (const i in this.formData.cols){
                            if (this.formData.cols[i].field=="topicId"){
                                this.formData.cols[i].optionList=data
                            }
                        }
                        for (const i in this.updateData.cols){
                            if (this.updateData.cols[i].field=="topicId"){
                                this.updateData.cols[i].optionList=data
                            }
                        }

                    }
                });
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(window.$t("common.search") == clickName ||"查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data);
                }else if(window.$t("common.add")==clickName){
                  this.$refs.childUpdate.open();
                }else if(window.$t("other.topic.export") == clickName){
                  this.downloadTopicComments(data);
                }else if(window.$t("other.topic.batchUpdate") == clickName){
                  this.batchSubmit(data);
                }
            },

            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage(Url.topicUser.addOrUpdate,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        { title: window.$t("other.topic.startTime"), field: 'startDate',type:5,format:"yyyy-MM-dd HH:mm:ss"},
                        { title: window.$t("other.topic.endTime"), field: 'endDate',type:5,format:"yyyy-MM-dd HH:mm:ss"},
                        { title: window.$t("other.topic.topic"), field: 'topicId',type:2,optionList:topicList,data:this.$route.query.topicId},
                        { title: window.$t("other.topic.status"), field: 'topicStatus',type:2,optionList:commentStatus},
                        { title: window.$t("other.topic.opType"), field: 'opType',type:2,optionList:opType},
                        {click:window.$t("common.search")},
                        {click: window.$t("common.add")},
                        {click: window.$t("other.topic.export")},
                        {click: window.$t("other.topic.batchUpdate")},
                    ]
                },
                batchData:{
                    hasLable: false,
                    cols:[
                        { title: window.$t("other.topic.topic"), field: 'topicId',type:2,optionList:topicList,data:this.$route.query.topicId,required:true},
                    ]
                },
                /*新增*/
                updateData: {
                    hasLable: true,
                    cols:[
                        { title: window.$t("other.topic.topic"), field: 'topicId',type:2,optionList:topicList,data:this.$route.query.topicId,required:true},
                        { title: window.$t("other.topic.customerNo"), field: 'customerNo',required:true,required:true},
                        { title: window.$t("other.topic.createTime"), field: 'createTime',type:5,format:"yyyy-MM-dd HH:mm:ss",required:true},
                        { title: window.$t("other.topic.opType"), field: 'opType',type:2,optionList:opType,data:"1",required:true},
                        { title: window.$t("other.topic.likeCount"), field: 'supportCount',type:7,required:true,data:0,min:0,precision:0},
                        { title: window.$t("other.topic.commentContent"), field: 'remark',textType:"textarea",required:true}
                      ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: Url.topicUser.query,
                    selection: true,
                    sequence: false,
                  method:"get",
                    cols: [
                        { title: 'ID', field: 'id'},
                        { title: window.$t("other.topic.titleName"), field: 'title'},
                        { title: window.$t("other.topic.opType"), type:2,field: 'opType',render:(data)=>{
                                return opType[data];
                         }},
                        { title: window.$t("other.topic.commentContent"), field: 'remark'},
                        { title: window.$t("other.topic.createTime"), field: 'createTime'},
                        { title: window.$t("other.topic.updateTime"), field: 'updateTime'},
                        { title: window.$t("other.topic.customerNo"), field: 'customerNo'},
                        { title: window.$t("other.topic.likeCount"), field: 'supportCount'},
                        { title: window.$t("other.topic.status"), field: 'topicStatus',render:(data)=>{
                                return commentStatus[data];
                            }},
                        {title: window.$t("common.handle"),width:'280px',btnClick:[
                            {
                             name:(data,full)=>{
                                        return full.topicStatus==0 || full.topicStatus== 2?window.$t("other.public.pass"):window.$t("other.public.noPass")
                               },click:"updateStatus",type:"primary",icon:"el-icon-delete",confirm:true
                           },
                                {
                                    name:(data,full)=>{
                                        return full.seq==0 ? window.$t("other.topic.top"): window.$t("other.topic.notTop")
                                    },click:"top",type:"primary",icon:"el-icon-delete",confirm:true
                                }
                            ]
                        },
                    ]
                }
            }
        }
    }
</script>
